
import React from 'react';
import { cn } from '@/lib/utils';
import { Button, ButtonProps } from '@/components/ui/button';

interface IconButtonProps extends ButtonProps {
  icon: React.ReactNode;
  'aria-label': string;
}

export const IconButton: React.FC<IconButtonProps> = ({ 
  icon, 
  className, 
  'aria-label': ariaLabel,
  ...props 
}) => {
  return (
    <Button
      type="button"
      aria-label={ariaLabel}
      className={cn("p-2 flex items-center justify-center", className)}
      {...props}
    >
      {icon}
    </Button>
  );
};

export default IconButton;
